//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function TransitionSixth() {
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{t('onboarding.nutritionSuccess.title')}</Title>
        <Text semibold className={styles.description}>
          {t('onboarding.nutritionSuccess.subTitle')}
        </Text>
      </div>
      <div className={styles.circles}>
        <div className={styles.circleGreen}>
          <Title tag='h3'>{t('onboarding.nutritionSuccess.80Percent')}</Title>
          <Text semibold className={styles.text}>
            {t('onboarding.nutritionSuccess.nutritionPercent')}
          </Text>
        </div>
        <div className={styles.circleWhite}>
          <Title tag='h3'>{t('onboarding.nutritionSuccess.20Percent')}</Title>
          <Text semibold className={styles.text}>
            {t('onboarding.nutritionSuccess.exercisePercent')}
          </Text>
        </div>
      </div>
      <div className={styles.continue}>
        <div className={styles.blur}></div>

        <Button onClick={onNext} title={t('onboarding.nutritionSuccess.continue')} />
      </div>
    </div>
  );
}

export default TransitionSixth;
